module.exports = __webpack_public_path__ + "img/powr.55aee257.svg";